import {
    Component,
    OnInit,
    ViewChild,
    AfterViewInit
} from '@angular/core';
import { PartInfo } from 'src/app/models/partinfo';
import { ProposalService } from 'src/app/services/proposal.service';
import { of } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { PendingProposalPartInfo } from 'src/app/models/internal/pendingproposalpartinfo';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { Constants } from 'src/app/core/constants';
import { QueryPendingProposalDTO } from 'src/app/models/internal/query-pendingproposal-dto';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { CopyProposalDTO } from 'src/app/models/internal/copy-proposal-dto';
import { CopyFromProposalDTO } from 'src/app/models/internal/copyfrom-proposal-dto';
import { AppSettingsDTO } from 'src/app/models/internal/appsettings-dto';
import { DueDateExtensionAppSettingsDTO } from 'src/app/models/duedateextension-appsettings-dto';
import { CopyfromProposalListComponent } from '../copyfrom-proposal-list/copyfrom-proposal-list.component';
import { SearchFilter_PendingProposals } from 'src/app/models/filters/searchfilter-pendingproposals';
import {SourceType} from 'src/app/models/sourcetype';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import UIHelper from 'src/app/core/utility/ui-helper';
import * as moment from 'moment';
import Helper from 'src/app/core/utility/helper';
import { NGXLogger } from 'ngx-logger';
import { environment } from 'src/environments/environment';
import { AppSettings } from 'src/app/app.settings';
import { ICanExportData } from 'src/app/core/interfaces/can-export-data.interface';
import { QueryPartProposalsSearchDTO } from 'src/app/models/internal/query-partproposals-search-dto';
import { element } from 'protractor';
import { DueDateExtensionHistoryDTO } from 'src/app/models/duedateextensionhistory-dto';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DuedateextensionHistoryComponent } from '../../../commonUI/duedateextension-history/duedateextension-history.component';
import { OpenactionsComponent } from '../openactions/openactions.component';

import { last } from '@angular/router/src/utils/collection';
import { filter } from 'rxjs/operators';
import { BaseOpenActionsPage } from '../../../core/basepages/allbasepages';
import { PackageType } from '../../../models/packagetype';
@Component({
    selector: 'app-Pendingproposallist',
    templateUrl: './pendingproposallist.component.html',
    styleUrls: ['./pendingproposallist.component.scss'],
})
export class PendingproposallistComponent extends BaseOpenActionsPage implements OnInit, AfterViewInit, ICanExportData {
    excelFilenamePrefix = 'PendingProposals_';
    pageSizes: number[] = [10, 25, 50];
    searchFilter_PendingProposals: SearchFilter_PendingProposals = new SearchFilter_PendingProposals();
    filterForm: FormGroup;
    pendingProposalsForm: FormGroup;
    showBase7proposalsMessageFound = false;
    showBase7proposalsMessageNotFound = false;
    base7proposalsFoundMessage: string;
    base7proposalsNotFoundMessage: string;
    POUoM: string;
    partPendingProposalInfoList: PendingProposalPartInfo[];
    partInfoIds: number[];
    sourceProposalsToCopyFromList: any[];
    partProposalInfoToBeCreatedList: PendingProposalPartInfo[];
    sourceTypeList: SourceType[];
    partSystemList: PartSystemDTO[];
    packageTypeList: PackageType[];
    isInboundShipment: boolean = true;
    allItemsCheckBoxSelected: boolean = false;
    locStorage = Constants.localStorageKeys;
    targetPartInfoIdList: PendingProposalPartInfo[] = [];
    showCopyFromComponent = false;
    childControlTooltipText: string = '';
    dueDateExtensionAppSettings: DueDateExtensionAppSettingsDTO;
    filteredDDERequestHistoryList: DueDateExtensionHistoryDTO[];
    filteredAdhocDDERequestHistoryList: DueDateExtensionHistoryDTO[];

    public formErrorsPendingproposalList = {
        HotRequestFlag: '',
        PartNumber: '',
        SourceTypeId: '',
        PartCategoryId: '',
        DemandDateFrom: '',
        DemandDateTo: '',
        DueDateFrom: '',
        DueDateTo: ''
    };

    @ViewChild(CopyfromProposalListComponent)
    CopyFromProposalListComponent: CopyfromProposalListComponent;
    displayedColumns: string[] = [
        'Select',
        'PartNumber',
        'POUomCode',
        'ViewProposal'
    ];

    // @ViewChildren("mainGrid")
    // public Grids: QueryList<TeslaGridComponent>
    // mainGrid: TeslaGridComponent;
    public formErrors = {
        itemsSelected: '',
    };
    copySourceUom: string;

    searchClicked = false;
    constructor(
        private dataService: DataService,
        private fb: FormBuilder,
        private proposalService: ProposalService,
        localstorageService: LocalstorageService,
        private toastService: ToastService,
        private formService: FormService,
        private router: Router,
        appSettings: AppSettings,
        logger: NGXLogger,
        private matDialog: MatDialog
    ) {
        super(localstorageService, logger, appSettings);
        this.pendingProposalsForm = this.fb.group({
            itemsSelected: [null]
        });
        this.filterForm = this.fb.group({
            SourceTypeId: [null],
            PartNumber: [null],
            HotRequestFlag: [null],
            PartCategoryId: [null],
            DemandDateFrom: [null],
            DemandDateTo: [null],
            DueDateFrom: [null],
            DueDateTo: [null]
        });
        this.dueDateExtensionAppSettings = new DueDateExtensionAppSettingsDTO();
    }

    ngOnInit() {
        this.initFilterValues();
        this.getSourceTypes();
        this.getPartSystems();
        this.getPackageTypes();
        // TMS-15768 to get appsettings regarding due date extension (before page load)
        this.getDueDateExtensionAppSettings();
        this.fillGrid();
    }

    fillGrid(): void {
        this.logger.debug('In fillGrid');
        this.sourceProposalsToCopyFromList = [];
        this.filter.Skip = this.skip;
        this.filter.Take = this.pageSize;
        this.allItemsCheckBoxSelected = false;
        const queryPendingProposalDTO: QueryPendingProposalDTO = {
            SearchFilter: this.filter,
            HotRequest: this.filterForm.get('HotRequestFlag').value
        };
        this.getPendingProposals(queryPendingProposalDTO);
    }

    formatDate(unformattedDate: Date) {
        return Helper.formatDate(unformattedDate);
    }

    exportData() {
        const filename = this.excelFilenamePrefix + Helper.formatDateTime(new Date()) + '.xlsx';
        const queryPendingProposalDTO: QueryPendingProposalDTO = {
            SearchFilter: this.filter,
            HotRequest: this.filterForm.get('HotRequestFlag').value
        };
        this.UpdateFilter();
        this.dataService
            .getPendingProposalsExcel(queryPendingProposalDTO).subscribe((response: any) => {
            if (response != null && response.Success) {
                UIHelper.DownloadExcelFile(response.Data, filename);
            } else {
                this.toastService.error(
                    'Could not export data'
                );
            }
        });
    }

    initFilterValues(): void {
        this.filter = new SearchFilter();
    }

    showCopyOptions() {
        return (
            this.sourceProposalsToCopyFromList &&
            this.sourceProposalsToCopyFromList.length > 0
        );
    }

    getPendingProposals(queryPendingProposalDTO: QueryPendingProposalDTO) {
        this.UpdateFilter();
        this.dataService
            .getPendingProposals(queryPendingProposalDTO)
            .subscribe((response: any) => {
                // this.partInfo = response
                if (response != null) {
                    this.partPendingProposalInfoList = response.Data;
                    this.gridView = of({
                        data: response.Data,
                        total: response.Total ? response.Total : 0,
                    });
                }
            });
    }
    UpdateFilter() {
        this.filter.SearchFilterConditions = [];
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartNumber', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SourceTypeId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartCategoryId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        // TMS-16564 Part Search Enhancement > Add filters on demand date range and due date range.
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'DemandDateFrom', Constants.FILTER_DATATYPE_DATETIME,  Constants.FILTER_OPERATOR_TYPE_GREATERTHAN);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'DemandDateTo', Constants.FILTER_DATATYPE_DATETIME,  Constants.FILTER_OPERATOR_TYPE_LESSTHAN);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'DueDateFrom', Constants.FILTER_DATATYPE_DATETIME,  Constants.FILTER_OPERATOR_TYPE_GREATERTHAN);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'DueDateTo', Constants.FILTER_DATATYPE_DATETIME,  Constants.FILTER_OPERATOR_TYPE_LESSTHAN);
    }
    atLeastOneNewProposalOnCurrentPage() {
        if (this.partPendingProposalInfoList && this.partPendingProposalInfoList.length > 0) {
            const newProp = this.partPendingProposalInfoList.filter(
                a =>  !this.proposalDraftCreated(a)
            );
            return (newProp && newProp.length > 0);
        } else {
            return false;
        }
    }
    checkExistingProposalsToCopyFrom() {
        this.ValidateForm();
        if (this.pendingProposalsForm.valid) {

        const selectedParts = this.partPendingProposalInfoList.filter(
            a => a.IsSelected === true
        );
        if (!this.POUoM) {
        this.POUoM = selectedParts[0].POUomCode;
        }
        this.searchClicked = true;
        this.showCopyFromComponent = true;
        let defaultPartNumber = selectedParts[0].PartNumber;
        if (defaultPartNumber) {
            defaultPartNumber = defaultPartNumber.substring(0, 7);
        }
        this.CopyFromProposalListComponent.setDefaultPartNumber(defaultPartNumber);
        this.CopyFromProposalListComponent.fillGrid();
    }
    }

    /*
    TMS-12409 For pending proposal screen, a check is made while creating proposals for any
    part whether that part contains any existing proposals or not.

    Update:
    TMS-14551 Criteria for determining existing proposal
    Remove exising proposal check
    */
    createProposal() {
        this.ValidateForm();
        // this.proposalService.RefreshPartInfoids([8977]);
        if (this.pendingProposalsForm.valid) {

            const selectedParts = this.partPendingProposalInfoList.filter(
                a => a.IsSelected === true
            );
            // this.partInfoIds = Array.prototype.map.call(selectedParts, s => s.Id);
            // this.proposalService.RefreshPartInfoids([8977, 687991]);
            this.proposalService.RefreshpartInfoToBeCreatedList(selectedParts);
            this.router.navigate(['../', 'proposal']);
        }
    }

    // async checkExistingProposalsforSelectedParts(selectedPart: any) {
    //     let promises = [];
    //     let result = [];
    //     for(const eachPart of selectedPart){
    //         const queryPartProposalsSearchDTO: QueryPartProposalsSearchDTO = Helper.createQueryProposolDTO(eachPart);
    //         promises.push(Helper.findExistingProposals(queryPartProposalsSearchDTO,this.dataService));
    //     }
    //     result = await Promise.all(promises);
    //     const exisitingProposalResp : any = result.find(element => element.proposalFound);
    //     if(!exisitingProposalResp){
    //         this.router.navigate(['../', 'proposal']);
    //     }
    //     else{
    //         this.toastService.error(
    //             'Part Number ' + exisitingProposalResp.partNumber  + Constants.ERROR_MESSAGE_FOR_PROPOSAL_EXISTS
    //         );
    //     }
    // }

    copyProposal(copyFromProposalDTO: CopyFromProposalDTO) {
            this.targetPartInfoIdList = this.partPendingProposalInfoList.filter(
                a => a.IsSelected === true
            );
            const copyProposalDTO: CopyProposalDTO = {
                Id: 0,
                Enabled: true,
                IsSelected: true,
                SourcePartInfoId: copyFromProposalDTO.SourcePartInfoId,
                SourceProposalId: copyFromProposalDTO.SourceProposalId,
                TargetPartInfoIdList: this.targetPartInfoIdList,
                isForSupplier: true,
                isTeslaCreated: false,
                EffectiveFrom: copyFromProposalDTO.EffectiveFrom,
            };
            this.logDebug('copying prop with dto', copyFromProposalDTO);
            this.scrollToTop();
            this.dataService
            .copyProposal(copyProposalDTO)
            .subscribe((response: any) => {
                if (response != null) {
                    this.proposalService.RefreshsavedproposalIds(response.Data);
                    this.toastService.success('Proposal(s) copied to create the following records', true);
                    this.navigateToSavedProposals();
                    // this.router.navigate(['../']);
                } else {
                    this.toastService.error(
                        'Could not copy the proposal'
                    );
                }
            });
    }
    getSourceTypes() {
        this.dataService.getParentSourceTypes().subscribe((response: any) => {
            if (response && response.Data != null) {
                this.sourceTypeList = response.Data;
            }
        });
      }

      getPartSystemName(id: number) {
          if (id != null) {
            return this.partSystemList.find(x => x.Id === id).Description;
          }
          return '';
      }

      getPackageTypeName(id: number) {
        if (id) {
          return this.packageTypeList.find(x => x.Id === id).Description;
        }
        return this.packageTypeList.find(x => x.Id === 2).Description;
      }

      getPackageTypes() {
        this.dataService.getPackageTypes().subscribe((response: any) => {
          if (response && response.Success) {
            this.packageTypeList = response.Data;
          }
        });

      }

      getPartSystems() {
        this.dataService.getPartSystems().subscribe((response: any) => {
                if (response != null && response.Success) {
                    this.partSystemList = response.Data;
                    // this.partSystemList = this.excludeAlreadyAssignedPartSystems(this.partSystemList);
                }
            });
    }

    /**
     * TMS-15768 to get appsettings regarding due date extension (before page load)
     * (Parent TMS-14954 Due date management logic implementation)
     */
    getDueDateExtensionAppSettings() {
        this.dataService.getDueDateExtensionAppSettings()
                .subscribe((response: any) => {
                    if (response &&
                        response.Success &&
                        response['Data']) {
                        const dueDateExtensionAppSettingsDto = response['Data'];
                        if (!dueDateExtensionAppSettingsDto ||
                            !dueDateExtensionAppSettingsDto[Constants.systemParameters.MAX_DAYS_DUE_DATE_EXTENSION] ||
                            !dueDateExtensionAppSettingsDto[Constants.systemParameters.MAX_NO_OF_TIMES_DUE_DATE_EXTENSION] ||
                            !dueDateExtensionAppSettingsDto[Constants.systemParameters.MAX_OFFSET_DAYS_FOR_DUE_DATE_EXTENSION]) {
                            this.toastService.error('Could not fetch the Due Date Extension App Settings.');
                            return;
                        }
                        this.dueDateExtensionAppSettings.MaxDaysDueDateExtension = parseInt(dueDateExtensionAppSettingsDto[Constants.systemParameters.MAX_DAYS_DUE_DATE_EXTENSION]);
                        this.dueDateExtensionAppSettings.MaxNoOfTimesDueDateExtension = parseInt(dueDateExtensionAppSettingsDto[Constants.systemParameters.MAX_NO_OF_TIMES_DUE_DATE_EXTENSION]);
                        this.dueDateExtensionAppSettings.MaxOffsetDaysForDueDateExtension = parseInt(dueDateExtensionAppSettingsDto[Constants.systemParameters.MAX_OFFSET_DAYS_FOR_DUE_DATE_EXTENSION]);
                       // this.toastService.success('Fetched the Due Date Extension App Settings successfully.');
                    } else {
                        this.toastService.error('Could not fetch the Due Date Extension App Settings.');
                    }
                });
    }

    onRowSelectedChange(event: any, partInfo: PartInfo) {
        const isSelected: boolean = event.checked;
        if (isSelected) {
            // TMS-4154
            // OLD[temporarily allow to select only one part] NEW[Implementation for multiple select]
            if (this.checkIfOtherPartsWithDifferentUOMSelected(partInfo)) {
                partInfo.IsSelected = false;
                event.source.checked = false;
                this.toastService.error('All selected Parts must have the same UOM');
            } else {
                this.POUoM = partInfo.POUomCode;
                // TMS-39283 don't select parts with draft proposals which is creating multiple (duplicate) selection for the same combo (parts with draft props will have Id > 0)
            this.partPendingProposalInfoList.find(
                a => a.PartNumber === partInfo.PartNumber && a.SourceTypeId === partInfo.SourceTypeId && a.POUomCode === partInfo.POUomCode && a.Id === 0
            ).IsSelected = true;
            if (
                this.partPendingProposalInfoList.filter(a => a.IsSelected === true).length === this.partPendingProposalInfoList.length
            ) {
                this.allItemsCheckBoxSelected = true;
            }
            this.pendingProposalsForm.controls[
                'itemsSelected'
            ].setErrors(null);
        }
        } else {
            this.partPendingProposalInfoList.find(
                a => a.Id === partInfo.Id && a.SourceTypeId === partInfo.SourceTypeId && a.POUomCode === partInfo.POUomCode
            ).IsSelected = false;
            this.allItemsCheckBoxSelected = false;
        }
        this.proposalService.RefreshpartInfoToBeCreatedList(
            this.partPendingProposalInfoList
        );
    }

    deleteProposal(proposal) {
        if (Helper.confirmDeleteAction()) {
            this.dataService.deleteProposal(proposal.ProposalId).subscribe((response: any) => {
                if (response != null && response.Success) {
                    this.toastService.success('Proposal deleted successfully', true);
                    this.fillGrid();
                } else {
                    this.toastService.error(
                        'Could not delete the proposal'
                    );
                }
            });
        } else {
        this.toastService.info('You cancelled the delete request');
        }
    }

    checkIfOtherPartsWithDifferentUOMSelected(partInfo: PartInfo) {
        const selectedParts = this.partPendingProposalInfoList.filter(
            a => (a.IsSelected === true )
        );
        // first time a part is selected
        if (!selectedParts || selectedParts.length === 0) {
            return false;
        }
        let foundItem = null;
        foundItem = selectedParts.find(x => x.POUomCode !== partInfo.POUomCode);
        return foundItem;
    }

    setAllSelected(isSelected: boolean) {
        // this.partinfoList.map(function(part) {
        //     part.IsSelected = isSelected;
        //     return part;
        // });
        this.partPendingProposalInfoList.forEach(part => {
            if (!this.proposalDraftCreated(part)) {
                part.IsSelected = isSelected;
            }
        });
        this.proposalService.RefreshpartInfoToBeCreatedList(
            this.partPendingProposalInfoList
        );
    }
    proposalDraftCreated(part: PendingProposalPartInfo): boolean {
        return part.ProposalId > 0;
    }
    viewProposal(id: number) {
        this.proposalService.RefreshproposalToViewId(id);
        window.open('viewproposal/' + id, '_blank');
        // this.router.navigate(['../', 'pe-proposalsnapshot']).then(result => {  window.open(['../', 'pe-proposalsnapshot'], '_blank'); });
        // this.router.navigate(['../', 'pe-proposalsnapshot']);
    }

    SetHoteRequestFlag(event) {
        this.filterForm.controls['HotRequestFlag'].setValue(event.checked);
    }

    clearFilter() {
        this.filterForm.reset();
        this.filter.SearchFilterConditions = [];
        this.search();
        // var checkbox = document.getElementById("chkHotRequestFlag");
        // checkbox.indeterminate = true;
        // window.location.reload();
    }

    ValidateForm() {
        const selectedItems = this.partPendingProposalInfoList.filter(
            a => a.IsSelected === true
        );
        if (!selectedItems || selectedItems.length === 0) {
            this.pendingProposalsForm.controls[
                'itemsSelected'
            ].setErrors({ selectAtLeastOneGridRow: true });
            // this.formErrors.partNumberSelection = "Please select at least one part number";
        }
        this.formErrors = this.formService.validateForm(
            <FormGroup>this.pendingProposalsForm,
            this.formErrors
        );

    }

    getSourceType(dataItem) {
        if (dataItem.ParentSourceTypeId) {
            const source = this.sourceTypeList.find(x => x.Id == dataItem.ParentSourceTypeId);
            return UIHelper.supplierDisplayCell(source.Name, source.Description);
        } else {
            return UIHelper.supplierDisplayCell(dataItem.SourceTypeName, dataItem.SourceTypeDescription);
        }
    }

    navigateToSavedProposals() {
        this.router.navigate(['/saved-proposals'] );
        // window.location.href = '/saved-proposals/';

    }

    // Revert Based On TMS-5526
    // getExpiresIn(data: PendingProposalPartInfo) {
    //     const remainder = (moment(data.CreatedOn).diff(moment.utc(), 'days')) + 7;
    //     return remainder === 0 ? 'Expiring today' : 'Expires in ' + (remainder) + ' days';
    // }
    refreshToolTipText(code: string) {
        this.childControlTooltipText = Constants[code];
    }

    /*TMS-15767
    Open DueDateExtension pop up screen which shows history and
    provides option to extend due date for selected proposals
    TMS-19723
    Create Adhoc DDE Request and show history for the request cr
    */
    onDueDateClick(pendingProposalPartInfoDto: PendingProposalPartInfo) {
        const dialogRef = this.matDialog.open(DuedateextensionHistoryComponent, {
            height: '730px',
            width: '750px',
            data: pendingProposalPartInfoDto
        });
        dialogRef.afterClosed().subscribe(result => {
           // Reload pending proposals only if user revises the due date.
            if (dialogRef.componentInstance.dueDateExtensionForm.controls['revisedDueDate'].value) {
                this.fillGrid();
            }
            //Reload pending proposals when Adhoc DDE requested
            var filteredAdhocDDERequestSize = this.partPendingProposalInfoList.filter(x => x.DueDateExtensionHistory.filter(x => x.AdHocDueDateExtensionRequestStatusId != null))
            if (filteredAdhocDDERequestSize.length > 0) {
                this.fillGrid();
            }
        });
    }

    /*
    // return latest revised due date history record if exists so latest due date is refreshed else fall back to default due date of pending part
    TMS-19723 Commented out exisitng logic to fetch the most recent due date for each pending proposal.
    Added use case for Adhoc due date requested along with DDE request
    */
    getLatestDueDate(dataItem: any) {
        const ddeHistory = dataItem.DueDateExtensionHistory;
        this.filteredAdhocDDERequestHistoryList = ddeHistory.filter(x => x.AdHocDueDateExtensionRequestStatusId == Constants.AdhocDDE_APPROVED_STATUS_ID);
        this.filteredDDERequestHistoryList = ddeHistory.filter(x => x.AdHocDueDateExtensionRequestStatusId == null);
        const filteredAhocDDERListSize = this.filteredAdhocDDERequestHistoryList.length;
        const filteredDDERListSize = this.filteredDDERequestHistoryList.length;
        let latestADhocDueDate: Date;
        let latestDueDate: Date;

        //Get more recent regular requested duedate if exists else return original DueDate
        if (filteredDDERListSize > 0) {
            latestDueDate = this.filteredDDERequestHistoryList[filteredDDERListSize - 1].RevisedDueDate;
        }
        else {
            return this.formatDate(dataItem.DueDate);
        }

        //Get more recent approved adhoc due date if exists
        if (filteredAhocDDERListSize > 0) {
            latestADhocDueDate = this.filteredAdhocDDERequestHistoryList[filteredAhocDDERListSize - 1].RevisedDueDate;
        }

        //check if there is no adhoc request then return latest dd requested.
        if (latestDueDate != null && latestADhocDueDate == null) {
            return this.formatDate(latestDueDate);
        }
        //Check if regular dd request is greater than adhoc dd
        else if (latestDueDate > latestADhocDueDate) {
            return this.formatDate(latestDueDate);
        }
        else {
            return this.formatDate(latestADhocDueDate);
        }
    }
}
